import { autoRegisterFeature } from '@store/features/factory';

import { clinicDocumentsFeature } from './store/feature';

autoRegisterFeature(clinicDocumentsFeature);

export * from './components';
export * from './store';
export * from './types';
